import React, { Component } from 'react';
import {
    arrayOf,
    shape,
    number,
} from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { format } from 'date-fns';
import { en, es } from 'date-fns/locale';
import Shipment from './shipment';
import styles from './styles/list-item.scss';
import OrderState from './order-state';
import OrderSummary from './summary';
import BillShipAddress from '../shared/bill-ship-address';
import ShipmentsUtils from '../../services/shipments-utils';
import translations from '../../../translations/app-translations.json';

class ListItem extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            expanded: false,
        };
    }

    _panelHeaderMarkup() {
        const thisOrder = this.props.order;
        const lang = this.props.locale.currentLocale === 'es' ? es : en;

        return (
            <div className="col-lg-12">
                <div className="row hidden-xs hidden-sm hidden-md">
                    <div className="col-lg-2 col-xs-12">
                        <b>{thisOrder.number}</b>
                    </div>
                    <div className="col-lg-2 col-xs-12 text-center">
                        {format(new Date(thisOrder.attributes.created_at), 'd MMM', { locale: lang })}
                    </div>
                    <div className="col-lg-2 col-xs-12 text-center">
                        <OrderState state={thisOrder.state} />
                    </div>
                    <div className="col-lg-2 col-xs-12 text-center">
                        {`${thisOrder.ship_address.attributes.state_name}, ${thisOrder.ship_address.attributes.country_name}`}
                    </div>
                    <div className={`col-lg-2 col-xs-12 text-center ${styles.total}`}>
                        { thisOrder.display_total}
                    </div>
                    <div className="col-lg-2 col-xs-12 text-center" onClick={() => this.setState((prevState) => ({ expanded: !prevState.expanded }))}>
                        {this.state.expanded
                            ? <i className="pe-7s-angle-up pe-1x pe-va font-weight-bold" style={{ fontWeight: 'bold', fontSize: 20 }} />
                            : <i className="pe-7s-angle-down pe-1x pe-va font-weight-bold" style={{ fontWeight: 'bold', fontSize: 20 }} />}
                    </div>
                </div>
                <div className="row hidden-lg">
                    <div className="col-lg-2 col-xs-12">
                        <FormattedMessage id="order-number" defaultMessage="#Order" />
                        {': '}
                        <b>{thisOrder.number}</b>
                    </div>
                    <div className="col-lg-2 col-xs-12">
                        <FormattedMessage id="order-date" defaultMessage="Order Date" />
                        {': '}
                        {format(new Date(thisOrder.attributes.completed_at), 'd MMM', { locale: lang })}
                    </div>

                    <div className="col-lg-2 col-xs-12">
                        <OrderState state={thisOrder.state} />
                    </div>
                    {this.state.expanded
                        ? (
                            <i
                                className="pe-7s-angle-up pe-1x pe-va font-weight-bold"
                                style={{
                                    fontWeight: 'bold', fontSize: 20, position: 'absolute', top: 0, right: 10,
                                }}
                                onClick={() => this.setState((prevState) => ({ expanded: !prevState.expanded }))}
                            />
                        )
                        : (
                            <i
                                className="pe-7s-angle-down pe-1x pe-va font-weight-bold"
                                style={{
                                    fontWeight: 'bold', fontSize: 20, position: 'absolute', top: 0, right: 10,
                                }}
                                onClick={() => this.setState((prevState) => ({ expanded: !prevState.expanded }))}
                            />
                        )}
                </div>
            </div>
        );
    }

    render() {
        const { order: thisOrder, stores } = this.props;
        const shipments = thisOrder.shipments.sort(ShipmentsUtils.compareShipments);

        const storeIdsCount = ShipmentsUtils.countAmountOfStores(thisOrder.shipments);
        let lastStore;
        let cont = 0;

        const shipmentsMarkup = shipments.map((shipment, idx) => {
            const store = stores && stores.find((store) => store.id === shipment.attributes.store_ids[0]);
            if (store !== lastStore) {
                lastStore = store;
                cont = 0;
            } else {
                cont += 1;
            }

            return (
                <Shipment
                    key={idx}
                    store={stores.find((store) => store.id === shipment.attributes.store_ids[0])}
                    shipment={shipment}
                    address={thisOrder.ship_address}
                    order={this.props.order}
                    className="my-orders-shipment"
                    style={ShipmentsUtils.shipmentStylePadding(shipments, idx)}
                    hideStoreName={ShipmentsUtils.prevIsSameStore(shipments, idx)}
                    details={
                        `${translations[this.props.locale.currentLocale]['shipment.word']} ${cont + 1}`
                        + ` ${translations[this.props.locale.currentLocale]['of.word']} ${storeIdsCount[shipment.attributes.store_ids[0]]}`
                    }
                />
            );
        });

        return (
            <div className="row line-item-row">
                {this._panelHeaderMarkup()}
                {this.state.expanded && shipmentsMarkup}
                <div className="address-summary">
                    {this.state.expanded && <BillShipAddress billAddress={this.props.order.bill_address} shipAddress={this.props.order.ship_address} className="address" />}
                    {this.state.expanded && <OrderSummary key={this.props.order.id} order={this.props.order} stores={this.props.stores} isCheckoutSummary={false} className="list-item-summary" />}
                </div>
            </div>
        );
    }
}

export default ListItem;

ListItem.defaultProps = {
    order: {
        shipments: [],
    },
    stores: [],
};

ListItem.propTypes = {
    order: shape({
        shipments: arrayOf(shape({
            attributes: shape({
                store_ids: arrayOf(number),
            }),
        })),
    }),
    stores: arrayOf(shape({
        id: number,
    })),
};



/** WEBPACK FOOTER **
 ** ./src/components/order/list-item.jsx
 **/